import UserAccountMenu from "client/components/applicationTopBar/UserAccountMenu";
import Button from "client/components/layout/Button";
import Panel from "client/components/layout/Panel";
import SearchField from "client/components/layout/SearchField";
import Spacer from "client/components/layout/Spacer";
import { LayoutOrientations } from "client/globals";
import { IconFillStyles, SearchIcon } from "client/components/Iconset";
import { autoLoadProject } from "client/classes/utilities/ProjectUtils";

import { useEffect, useState } from "react";
import { shallowEqual } from "react-redux";
import config from "src/config";
import ScenarioList from "./ScenarioList";
import { useTypedSelector } from "../../state/hooks";
import { TooltipKeys } from "client/components/tooltips/TooltipKeys";

const Dashboard = () => 
{
	const sessionInfo = useTypedSelector(state => state.userModule.sessionInfo, shallowEqual);
	const dashboardRevisionGroup = useTypedSelector(state => state.worklinkModule.dashboardRevisionGroup);

	const [userName, setUserName] = useState("");
	const [searchQuery, setSearchQuery] = useState("");
	const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");

	useEffect(() => 
	{
		// auto load project
		const urlParams = new URLSearchParams(window.location.search);
		const autoLoadProjectID = urlParams.get('projectid');
		if (autoLoadProjectID) 
		{
			autoLoadProject(autoLoadProjectID);
			return;
		}
	}, []);

	useEffect(() => 
	{
		const setDebounced = setTimeout(() => 
		{
			setDebouncedSearchQuery(searchQuery);
		}, 300);

		return () => clearTimeout(setDebounced);
	}, [searchQuery]);

	useEffect(() =>
	{
		if(sessionInfo)
		{
			setUserName(sessionInfo.name || "Author");
		}
	}, [sessionInfo]);

	useEffect(() =>
	{
		if(dashboardRevisionGroup)
		{
			setSearchQuery("");
		}
	}, [dashboardRevisionGroup]);

	return sessionInfo && (
		<div className="dashboardRoot fullScreen"
			data-name="dashboard-root"
		>
			<div className={"welcomeScreenHeader"}
				data-name={"welcome-screen-header"}
			>
				<div className={"welcomeUserMessage"}>
					<div className="largeText" style={{ fontWeight: "500" }}>
						Welcome back, { userName }
					</div>
					<div style={{ fontSize: "11px" }}>
						Organization: { sessionInfo.companies?.at(0)?.name }
					</div>
				</div>
				<SearchField data-name={"welcome-screen-search-field"}
					className={"welcomeScreenSearchField"}
					value={searchQuery}
					placeholder={"Search"}
					onChangeCallback={setSearchQuery}
					autoFocus={true}
					prefixIcon={<SearchIcon fillStyle={IconFillStyles.steel900} />}
				/>
				<Spacer stretchTo={{ x: "100%" }} />
				<Panel data-name={"welcome-screen-user-menu-wrapper"}
					orientation={LayoutOrientations.Horizontal}
					expand={0}
				>
					{
						!config.USERFLOW_ENABLED ? null :
							<Button id={"userflow-placeholder"}
								data-name={"placeholder-ai-menu"}							
								className={"scenarioControlButton small"}
								style={{ backgroundColor: "#252525" }}
							/>
					}
					<UserAccountMenu />
				</Panel>
			</div>
			<ScenarioList searchFilter={debouncedSearchQuery} />
			<div className={"dashboardFooter"}
				data-name={"dashboard-footer"}
			>
				<a href={"https://www.scopear.com/privacy-policy"} target={"_blank"} rel={"noopener noreferrer"}>
					Privacy Policy
				</a>
				<div className={"productVersion"}
					data-name={"product-version"}
					data-tooltip={TooltipKeys.productVersion}
				>
					{ `v${config.productVersionFaceValue}` }
				</div>
			</div>
		</div>
	);
}

export default Dashboard;